export default __webpack_public_path__ + "static/media/vid-06.0b26d34d.mp4";